import { useEffect } from 'react';
import '../../shared/shared.scss';
import { Layout } from 'antd';
import AppFooter from './footer';
import AppHeader from './header';
import { Outlet } from 'react-router-dom'
import AppMenuSider from './siderMenu';
import { useCurrentUserContext } from '../../context/currentUserContext';
import { useDispatch } from 'react-redux';
import { fetchDivisionsList } from '../../state/slices/divisionsListSlice';
import { fetchRolesList } from '../../state/slices/rolesListSlice';
import { fetchSuppliersList } from '../../state/slices/suppliersListSlice';
import { fetchAnomaliesList } from '../../state/slices/anomaliesListSlice';
import { fetchDocumentTypesDistinteList, fetchDocumentTypesList } from '../../state/slices/documentTypesSlice';
import { fetchDocumentStatusList } from '../../state/slices/documentStatusSlice';
import { documentCategoryLayoutColor } from '../../utils/functions';
import { fetchRegionsList } from '../../state/slices/regionsListSlice';
import { fetchIntervetionTypes } from '../../state/slices/intervetionTypeSlice';
import { fetchusersList } from '../../state/slices/usersListSlice';

const { Content } = Layout;

const AppLayout = () => {
    const { currentUser } = useCurrentUserContext();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!currentUser) return;

        dispatch(fetchDivisionsList());
        dispatch(fetchRolesList());
        // dispatch(fetchSuppliersList(currentUser.lastSelectedCategory));
        dispatch(fetchAnomaliesList(currentUser.lastSelectedCategory));
        dispatch(fetchDocumentTypesList());
        dispatch(fetchDocumentTypesDistinteList());
        dispatch(fetchDocumentStatusList());
        dispatch(fetchRegionsList());
        dispatch(fetchIntervetionTypes());
        dispatch(fetchusersList());
    }, [dispatch, currentUser]); // ✅ API calls run once on app load

    return (
        <Layout className='appLayout'>
            {currentUser && (
                <>
                    <AppHeader />
                    <Layout className={documentCategoryLayoutColor(currentUser.lastSelectedCategoryCode)}>
                        <AppMenuSider />
                        <Layout style={{ padding: '10px 10px 10px' }}>
                            <Content className='content'>
                                <Outlet />
                            </Content>
                            <AppFooter />
                        </Layout>
                    </Layout>
                </>
            )}
        </Layout>
    );
};

export default AppLayout;